import { buildVenuePath } from '../utils/venueRouting';
// src/pages/Service.jsx
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import SearchTabs from '../components/SearchTabs';
import AdvTabs from '../components/AdvTabs.js';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
// import { FunnelIcon } from '@heroicons/react/24/outline';
import BackButton from '../components/BackButton';
import { contentLog } from '../utils/Accesslog.js';
import { getLuminance } from '../utils/ColorLuminance.js';
import { resolveSidebarIconSrc } from '../utils/IconSource.js';

const Service = () => {
  const { hotelInfo, contentInfo, venueId, theme } = useContext(AppContext);
  const navigate = useNavigate();
  const [hotelContent, setHotelContent] = useState(null);
  const [tabSwitch, setTabSwitch] = useState(sessionStorage.getItem('tabSwitch') ? sessionStorage.getItem('tabSwitch') === 'true' : true);
  // true表示   banner展示
  // false表示  icon展示
  // const [sortOrder, setSortOrder] = useState('natural');// natural asc desc

  useEffect(() => {
    if (contentInfo && contentInfo.attributes) {
      setHotelContent(contentInfo.attributes.find(data => data.searchTags === "HotelManagedEndpoint"))
    }
  }, [contentInfo])

  // const toggleSortOrder = () => {
  //   const tempAttributes = [...hotelContent.attributes];
  //   if (sortOrder === 'natural') {
  //     tempAttributes.sort((a, b) => a.name.localeCompare(b.name));
  //     setHotelContent({
  //       ...hotelContent,
  //       attributes: tempAttributes
  //     });
  //     setSortOrder('asc')
  //   } else if (sortOrder === 'asc') {
  //     tempAttributes.sort((a, b) => b.name.localeCompare(a.name));
  //     setHotelContent({
  //       ...hotelContent,
  //       attributes: tempAttributes
  //     });
  //     setSortOrder('desc')
  //   } else if (sortOrder === 'desc') {
  //     if (contentInfo && contentInfo.attributes) {
  //       setHotelContent(contentInfo.attributes.find(data => data.searchTags === "HotelManagedEndpoint"))
  //     }
  //     setSortOrder('natural')
  //   }
  // }

  const handleServiceClick = (data) => {
    contentLog(venueId, data.id);
    if (data.isLeaf) {
      navigate(buildVenuePath(`/service/detail/${data.id}`, venueId))

    }
    else
      navigate(buildVenuePath(`/service/list/${data.id}`, venueId))
  }
  if (!hotelInfo) { return <div>Loading...</div>; }
  const themeColor = theme?.primaryColor || theme?.color || 'rgb(0,0,0)';
  const textColor = theme?.secondaryColor || 'rgb(255,255,255)';
  const designedColor = getLuminance(themeColor) > 0.7 ? textColor : themeColor;

  const servicesHeader = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.servicesHeader || 'rgb(0,0,0)');
  const servicesContent = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.servicesContent || 'rgb(0,0,0)');
  const servicesEntries = (theme?.color || theme?.secondaryColor) ? designedColor : (theme?.servicesEntries || 'rgb(0,0,0)');
  const servicesBackground = (theme?.color || theme?.secondaryColor) ? "rgb(255,255,255)" : theme?.servicesBackground || 'rgb(255,255,255)';
  const topIcons = (theme?.color || theme?.secondaryColor) ? designedColor : theme?.topIcons || 'rgb(0,0,0)';


  return (
    <div style={{ backgroundColor: servicesBackground }}>
      {tabSwitch ?
        <div className='min-h-[calc(100vh-9rem)]'>
          <div className='mb-4'>
            {hotelInfo && hotelInfo.landing && hotelInfo.landing.serviceImages && hotelInfo.landing.serviceImages.length > 0 && (
              hotelInfo.landing.serviceImages.length === 1 ?
                <img src={hotelInfo.landing.serviceImages[0]} alt='serviceImage' className='object-cover w-full h-36' /> :
                <Carousel
                  showArrows={true}
                  showThumbs={false}
                  infiniteLoop={true}
                  autoPlay={true}
                  showIndicators={false}
                  showStatus={false}
                  className="w-full h-full"
                >
                  {hotelInfo.landing.serviceImages.map((slide, index) => (
                    <div key={index} className="w-full h-full">
                      <img
                        src={slide}
                        alt={`Home ${index + 1}`}
                        className="object-cover w-full h-36"
                      />
                    </div>
                  ))}
                </Carousel>
            )}
            {hotelInfo && hotelInfo.landing && hotelInfo.landing.serviceTitle && hotelInfo.landing.serviceTitle.length > 0 &&
              <p className='text-xl text-center p-2 font-semibold' style={{ color: servicesHeader }}>{hotelInfo.landing.serviceTitle}</p>}
            {hotelInfo && hotelInfo.landing && hotelInfo.landing.serviceDescription && hotelInfo.landing.serviceDescription.length > 0 &&
              <p className='px-6 text-gray-600 text-xs whitespace-pre-wrap' style={{ color: servicesContent }}>{hotelInfo.landing.serviceDescription}</p>}
          </div>
          {hotelContent && <div className='grid grid-cols-2 max-w-md mx-auto px-2 pb-2'>
            <div key="root" className="flex flex-col items-center px-2 pt-2" onClick={() => { setTabSwitch(false); sessionStorage.setItem('tabSwitch', false); }}>
              <div className="w-full aspect-w-1 aspect-h-1">
                <img
                  src={hotelContent.bannerImage}
                  alt={`List Root`}
                  className="object-cover rounded-lg w-full h-full"
                />
              </div>
              <p className="mt-1 font-semibold" style={{ color: servicesEntries }}>{hotelContent.name}</p>
            </div>
            {hotelContent.attributes.length > 0 &&
              hotelContent.attributes.filter(data => !data.isLeaf).map((data, index) => (
                <div key={data.id} className="flex flex-col items-center px-2 pt-2"
                  onClick={() => handleServiceClick(data)}>
                  <div className="w-full aspect-w-1 aspect-h-1">
                    <img
                      src={data.bannerImage}
                      alt={"BannerImage " + index}
                      className="object-cover rounded-lg w-full h-full"
                    />
                  </div>
                  <p className="mt-1 font-semibold text-center" style={{ color: servicesEntries }}>{data.name}</p>
                </div>
              ))}
          </div>}
          <AdvTabs origin={'Home'} />
        </div>
        :
        <div className='min-h-[85vh] overflow-y-hidden'>
          <BackButton onClick={() => { setTabSwitch(true); sessionStorage.setItem('tabSwitch', true); }} style={{ color: topIcons }} />
          <div>
            {hotelInfo && hotelInfo.landing && hotelInfo.landing.serviceImages && hotelInfo.landing.serviceImages.length > 0 && (
              hotelInfo.landing.serviceImages.length === 1 ?
                <img src={hotelInfo.landing.serviceImages[0]} alt='serviceImage' className='object-cover w-full h-36' /> :
                <Carousel
                  showArrows={true}
                  showThumbs={false}
                  infiniteLoop={true}
                  autoPlay={true}
                  showIndicators={false}
                  showStatus={false}
                  className="w-full h-full"
                >
                  {hotelInfo.landing.serviceImages.map((slide, index) => (
                    <div key={'carousel' + index} className="w-full h-full">
                      <img
                        src={slide}
                        alt={`Home ${index + 1}`}
                        className="object-cover w-full h-36"
                      />
                    </div>
                  ))}
                </Carousel>
            )}
          </div>
          {hotelContent && <div>
            <div className="flex flex-col items-center px-2 py-4 ">
              <p className="font-semibold text-xl" style={{ color: servicesHeader }}>{hotelContent.name}</p>
              <div className="flex items-center mt-2 mx-2 w-full px-2">
                {/* Search Input */}
                {/* <input
                  type="text"
                  placeholder="Search"
                  className="border rounded-t-md p-2 w-full flex-grow"
                  onChange={handleSearchChange}
                  id='input entry'
                /> */}
                <div className='grow'>
                  <SearchTabs isHotelOnly={true} />

                </div>

                {/* <FunnelIcon className="h-10 w-10 mx-2 text-white" onClick={toggleSortOrder} /> */}
                {/* {searchResults.length > 0 &&
                  <div className="absolute left-0 right-0 top-80 mt-1 ml-4 bg-white z-10 overflow-hidden" style={{ marginRight: '4.5rem' }}>
                    {searchResults.map((result) => (
                      <div key={result.id} className="py-4 cursor-pointer flex flex-row pl-4"
                        onClick={() => navigate(buildVenuePath(`/service/detail/${result.id}`, venueId))}>
                        <p className="text-sm">{result.name}</p>
                      </div>
                    ))}
                  </div>} */}
              </div>

            </div>
            <div className="grid grid-cols-2 max-w-md mx-auto px-2">
              {hotelContent.attributes.length > 0 &&
                hotelContent.attributes.map((data, index) => {
                  const isSidebar = hotelContent.layoutStyle === "sidebar";
                  const iconSrc = resolveSidebarIconSrc(data);

                  return (
                    <div
                      key={data.id}
                      className={`flex flex-col items-center px-2 ${isSidebar ? 'bg-white py-2 m-2' : ''} rounded-lg min-h-28`}
                      onClick={() => handleServiceClick(data)}
                    >
                      {/* 如果是 sidebar，就直接用 12x12；否则用“充满宽度且保持正方形” */}
                      {isSidebar ? (
                        <div className="w-full flex items-center justify-center m-2">
                          {iconSrc && (
                            <img
                              src={iconSrc}
                              alt={`IconImage ${index}`}
                              className="object-cover rounded-lg w-12 h-12"
                              onError={(event) => {
                                event.currentTarget.style.display = 'none';
                              }}
                            />
                          )}
                        </div>
                      ) : (
                        <div className="w-full m-2">
                          {/* 这里的容器负责保持 1:1 比例 */}
                          <div className="relative w-full aspect-w-1 aspect-h-1 overflow-hidden rounded-lg">
                            <img
                              src={data.bannerImage}
                              alt={`BannerImage ${index}`}
                              className="absolute inset-0 w-full h-full object-cover"
                            />
                          </div>
                        </div>
                      )}

                      <p
                        className="font-semibold text-center mt-0 text-sm"
                        style={{ color: servicesEntries }}
                      >
                        {data.name}
                      </p>
                    </div>
                  );
                })}
            </div>


          </div>}
        </div>
      }
    </div>


  );
};

export default Service;
